// export const apiURL = "http://192.168.1.171:10000/";
export const apiURL = "https://springapi-xsvy.onrender.com/";

export const paymentServerURL = "https://payment-pqnu.onrender.com/"
// export const paymentServerURL = "http://192.168.1.171:8000/"